/* Naguirre — gaveta "padrão ouro" (03/10/2026): comportamento.
   - setas de "Você também pode gostar";
   - linhas "Cupom" e "Frete" que abrem e fecham (o estado sobrevive ao redesenho da gaveta);
   - cupom num campo igual ao do CEP, aplicado direto no carrinho da Shopify (/cart/update.js com
     "discount"), com a memória dos apps de cupom acertada para eles não reaplicarem o que saiu;
   - consulta de frete pelo CEP, com o mesmo cálculo do checkout (assets/naguirre-frete.js).
   A gaveta é redesenhada pelo tema a cada mudança: tudo aqui usa delegação de eventos e
   reaplica o estado quando o tema avisa (evento "cart-update") ou quando a lista muda. */
(function () {
  'use strict';

  var raiz = document.getElementById('halo-cart-sidebar');
  if (!raiz) return;

  var abertos = { cupom: false, frete: false };

  function escapar(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function focar(campo) {
    if (campo) setTimeout(function () { try { campo.focus({ preventScroll: true }); } catch (e) { campo.focus(); } }, 50);
  }

  // ---------- Setas das sugestões ----------
  function passo(lista) {
    var card = lista.querySelector('.ng-sug__card');
    var gap = parseFloat(getComputedStyle(lista).columnGap || getComputedStyle(lista).gap) || 12;
    return card ? card.getBoundingClientRect().width + gap : lista.clientWidth * 0.8;
  }
  function atualizarSetas(bloco) {
    var lista = bloco.querySelector('[data-ng-sug-lista]');
    if (!lista) return;
    var max = lista.scrollWidth - lista.clientWidth - 2;
    bloco.querySelectorAll('[data-ng-sug-seta]').forEach(function (b) {
      var dir = Number(b.getAttribute('data-ng-sug-seta'));
      b.disabled = dir < 0 ? lista.scrollLeft <= 2 : lista.scrollLeft >= max;
    });
  }
  raiz.addEventListener('click', function (ev) {
    var seta = ev.target.closest('[data-ng-sug-seta]');
    if (!seta) return;
    var bloco = seta.closest('[data-ng-sugestoes]');
    var lista = bloco && bloco.querySelector('[data-ng-sug-lista]');
    if (!lista) return;
    lista.scrollBy({ left: Number(seta.getAttribute('data-ng-sug-seta')) * passo(lista), behavior: 'smooth' });
  });
  raiz.addEventListener('scroll', function (ev) {
    if (ev.target && ev.target.matches && ev.target.matches('[data-ng-sug-lista]')) {
      atualizarSetas(ev.target.closest('[data-ng-sugestoes]'));
    } else if (ev.target && ev.target.classList && ev.target.classList.contains('previewCart')) {
      // Lista rolada: aparece a linha sob "Meu Carrinho" (sem ela, o que sobe encostava no título).
      raiz.classList.toggle('ng-lista-rolada', ev.target.scrollTop > 4);
    } else if (ev.target && ev.target.classList && ev.target.classList.contains('previewCartInfo')) {
      marcarRodape();
    }
  }, true);
  // Rodapé que não cabe (painel aberto em tela baixa) rola por trás do "Finalizar a compra", que fica
  // preso embaixo: enquanto houver conteúdo escondido atrás dele, ganha uma sombra em cima.
  function marcarRodape() {
    var r = raiz.querySelector('.previewCartInfo');
    raiz.classList.toggle('ng-rodape-rola', !!(r && r.scrollTop + r.clientHeight < r.scrollHeight - 2));
  }
  window.addEventListener('resize', function () { marcarRodape(); });

  // ---------- Linhas Cupom / Frete (abrir e fechar) ----------
  // A linha inteira é o botão; aberta, ela mostra "Fechar" no lugar do resumo (CSS por aria-expanded).
  function aplicarPaineis() {
    Object.keys(abertos).forEach(function (nome) {
      var painel = raiz.querySelector('[data-ng-painel="' + nome + '"]');
      var botao = raiz.querySelector('[data-ng-abrir="' + nome + '"]');
      if (painel) painel.hidden = !abertos[nome];
      if (botao) botao.setAttribute('aria-expanded', abertos[nome] ? 'true' : 'false');
    });
  }
  raiz.addEventListener('click', function (ev) {
    var botao = ev.target.closest('[data-ng-abrir]');
    if (!botao) return;
    ev.preventDefault();
    var nome = botao.getAttribute('data-ng-abrir');
    abertos[nome] = !abertos[nome];
    if (!abertos[nome] && nome === 'cupom') mensagemCupom = null; // fechou: a próxima abertura começa limpa
    aplicarPaineis();
    aplicarMensagemCupom();
    marcarRodape();
    if (abertos[nome]) focar(raiz.querySelector(nome === 'frete' ? '[data-ng-cep]' : '[data-ng-cupom]'));
  });

  // ---------- Cupom ----------
  var mensagemCupom = null; // { tipo: 'ok'|'erro'|'aviso', texto } — sobrevive ao redesenho
  var cupomOcupado = false;
  // Cupons do carrinho como o /cart.js mostra ({ code, applicable }). O Liquid (cart.discount_applications)
  // só enxerga cupom que já desconta nas peças: cupom de FRETE (ex.: GUGAFRETE) não aparece lá, e a linha
  // ficava "Adicionar" com o cupom ativo. Pior: aplicar outro cupom mandava a lista sem ele e o tirava.
  var cuponsCarrinho = null; // null = ainda não lido (vale o que o Liquid mostra)
  var versaoCupons = 0;      // sobe a cada escrita: leitura que começou antes dela chega velha e é descartada
  var LIXO = ['~', 'sd_clear_discount']; // restos dos apps de cupom; não são cupons

  function guardarCupons(lista) {
    if (!Array.isArray(lista)) return;
    cuponsCarrinho = lista.map(function (d) { return { code: String(d.code || ''), applicable: !!d.applicable, nasPecas: !!d.nasPecas }; })
      .filter(function (c) { return c.code && LIXO.indexOf(c.code.toLowerCase()) === -1; });
  }
  function cuponsAtivos() {
    if (cuponsCarrinho) return cuponsCarrinho.map(function (c) { return c.code; });
    var el = raiz.querySelector('[data-ng-cupons-ativos]');
    return (el ? el.getAttribute('data-ng-cupons-ativos') : '').split('|').filter(Boolean);
  }
  // Lê o carrinho antes de mexer nos cupons: a lista enviada à Shopify SUBSTITUI a que está lá.
  function cuponsFrescos() {
    var NF = window.NaguirreFrete;
    if (!NF || typeof NF.lerCarrinho !== 'function') return Promise.resolve(cuponsAtivos());
    var versao = versaoCupons;
    return NF.lerCarrinho().then(function (c) {
      if (versao === versaoCupons) guardarCupons(c.cupons);
      return cuponsAtivos();
    }, function () { return cuponsAtivos(); });
  }
  var esperaCupons = null;
  function lerCuponsDoCarrinho() {
    var NF = window.NaguirreFrete;
    if (!NF || typeof NF.lerCarrinho !== 'function') return;
    clearTimeout(esperaCupons);
    esperaCupons = setTimeout(function () {
      var versao = versaoCupons;
      NF.lerCarrinho().then(function (c) {
        if (versao !== versaoCupons) return;
        conferirCarrinho(c);
        freteDepoisDoRedesenho(); // entrou ou saiu cupom de frete: a conta do frete pode ter mudado
      }).catch(function () {});
    }, 250);
  }
  // A gaveta pode ter sido desenhada antes de um app de cupom mexer no carrinho (o Discount On Cart Pro
  // reaplica o cupom guardado; visto no teste de 04/10): o /cart.js diz um total e o Liquid outro, ou há
  // cupom descontando nas peças que o Liquid não mostrou. Aí a gaveta é redesenhada pelo próprio tema.
  // Sem laço: a mesma diferença nunca pede redesenho duas vezes, e no máximo 6 por minuto.
  var redesenhosForcados = [];
  var ultimaDiferenca = '';
  function pedirRedesenho(diferenca) {
    if (cupomOcupado || diferenca === ultimaDiferenca) return;
    var agora = Date.now();
    redesenhosForcados = redesenhosForcados.filter(function (t) { return agora - t < 60000; });
    if (redesenhosForcados.length >= 6) return;
    redesenhosForcados.push(agora);
    ultimaDiferenca = diferenca;
    redesenhar();
  }
  function conferirCarrinho(c) {
    guardarCupons(c.cupons);
    desenharCupons();
    var tema = raiz.querySelector('[data-cart-total-value]');
    var noTema = tema ? parseInt(tema.getAttribute('data-cart-total-value'), 10) : NaN;
    var faltaNoLiquid = (cuponsCarrinho || []).some(function (x) { return x.applicable && x.nasPecas && !cupomNoLiquid(x.code); });
    if ((typeof c.total === 'number' && !isNaN(noTema) && c.total !== noTema) || faltaNoLiquid) {
      pedirRedesenho(c.total + '|' + (cuponsCarrinho || []).map(function (x) { return x.code + (x.nasPecas ? '+' : ''); }).join(','));
    }
  }
  function cupomNoLiquid(codigo) {
    var achou = false;
    raiz.querySelectorAll('.ng-cupom__aplicado:not(.ng-cupom__aplicado--js) [data-ng-remover-cupom]').forEach(function (b) {
      if (String(b.getAttribute('data-ng-remover-cupom')).toLowerCase() === String(codigo).toLowerCase()) achou = true;
    });
    return achou;
  }

  // Linha "Cupom" e cartões dos cupons que o Liquid não desenha. Na prática, cupom de frete
  // (vale, mas não desconta nas peças) e cupom que não vale para a sacola (ex.: abaixo do mínimo).
  var ICONE_OK = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M8.2 13.6 4.6 10l-1.2 1.2 4.8 4.8 9-9-1.2-1.2z"/></svg>';
  function desenharCupons() {
    if (!cuponsCarrinho) return;
    var resumo = raiz.querySelector('[data-ng-cupom-resumo]');
    var validos = cuponsCarrinho.filter(function (c) { return c.applicable; });
    var texto = validos.length ? validos[0].code.toUpperCase() + ' ✓'
      : cuponsCarrinho.length ? cuponsCarrinho[0].code.toUpperCase() + ' não vale' : 'Adicionar';
    if (resumo && resumo.textContent.trim() !== texto) resumo.textContent = texto;
    var painel = raiz.querySelector('[data-ng-painel="cupom"]');
    if (!painel) return;
    var doLiquid = [];
    painel.querySelectorAll('.ng-cupom__aplicado:not(.ng-cupom__aplicado--js) [data-ng-remover-cupom]').forEach(function (b) {
      doLiquid.push(String(b.getAttribute('data-ng-remover-cupom')).toLowerCase());
    });
    var faltam = cuponsCarrinho.filter(function (c) { return doLiquid.indexOf(c.code.toLowerCase()) === -1; });
    var chave = faltam.map(function (c) { return c.code + (c.applicable ? '+' : '-') + (c.nasPecas ? 'p' : ''); }).join(',');
    if (painel.getAttribute('data-ng-cupons-js') === chave) return; // nada mudou desde o último desenho
    painel.setAttribute('data-ng-cupons-js', chave);
    painel.querySelectorAll('.ng-cupom__aplicado--js').forEach(function (e) { e.remove(); });
    var ancora = painel.querySelector('[data-ng-cupons-ativos]');
    faltam.forEach(function (c) {
      var cartao = document.createElement('div');
      cartao.className = 'ng-cupom__aplicado ng-cupom__aplicado--js' + (c.applicable ? '' : ' is-invalido');
      cartao.innerHTML = '<span class="ng-cupom__codigo">' + (c.applicable ? ICONE_OK : '') +
        '<span class="ng-cupom__nome"><strong>' + escapar(c.code.toUpperCase()) + '</strong><span class="ng-cupom__nota">' +
        (!c.applicable ? 'não vale para este carrinho' : c.nasPecas ? 'aplicado' : 'desconto no frete') + '</span></span></span>' +
        '<button type="button" class="ng-cupom__remover" data-ng-remover-cupom="' + escapar(c.code) + '">Remover</button>';
      painel.insertBefore(cartao, ancora);
    });
  }

  function aplicarMensagemCupom() {
    var alvo = raiz.querySelector('[data-ng-cupom-msg]');
    if (!alvo) return;
    var html = mensagemCupom ? '<p class="ng-cupom__' + mensagemCupom.tipo + '">' + escapar(mensagemCupom.texto) + '</p>' : '';
    if (alvo.innerHTML !== html) alvo.innerHTML = html;
  }
  function trocarCupons(lista) {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: lista.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      return r.json();
    }).then(function (carrinho) {
      versaoCupons++;
      guardarCupons(carrinho && carrinho.discount_codes);
      return carrinho;
    });
  }
  // Dois apps guardam os cupons e PÕEM DE VOLTA o que some do carrinho (visto em 03/10: tirado por
  // /cart/update.js, o cupom voltou na hora, em maiúsculas): o Discount On Cart Pro (Docapp; guarda em
  // localStorage "docapp-coupon"/"discount_code" e reaplica) e o dcart (guarda na sessão). A remoção do
  // próprio dcart falha aqui (GET /discount/~ deixa "~" no carrinho). Por isso: o cupom entra e sai
  // direto na Shopify (/cart/update.js com "discount") e, antes de tirar, a memória dos dois apps é
  // acertada pelas APIs deles. O Docapp de brinde lê o cupom pelo Discount On Cart Pro: não desligar.
  function sincronizarApps(removido, restantes) {
    var baixo = restantes.map(function (c) { return String(c).toLowerCase(); });
    try {
      // "...WithoutCartDiscountReset": o app só esquece o cupom; não manda o "SD_CLEAR_DISCOUNT" dele
      // para o carrinho (a remoção de verdade é a nossa, logo abaixo).
      var docp = window.discountOnCartProApp;
      if (removido && docp) {
        if (typeof docp.removeCodeWithoutCartDiscountReset === 'function') docp.removeCodeWithoutCartDiscountReset(String(removido).toUpperCase());
        else if (typeof docp.removeCode === 'function') docp.removeCode(String(removido).toUpperCase());
      }
    } catch (e) {}
    var api = window.dcartAPI && window.dcartAPI.discount;
    try {
      if (api && typeof api.getDiscountData === 'function' && typeof api.updateDiscountData === 'function') {
        var dados = api.getDiscountData() || {};
        var saem = (dados.codes || []).map(function (c) { return String(c).toLowerCase(); })
          .filter(function (c) { return baixo.indexOf(c) === -1; });
        var descontos = (dados.discounts || []).filter(function (d) {
          var nome = d && (d.code || d.title);
          return !nome || saem.indexOf(String(nome).toLowerCase()) === -1;
        });
        api.updateDiscountData({ codes: baixo, code: baixo.length ? baixo[baixo.length - 1] : null, discounts: descontos });
      }
    } catch (e) {}
    ['sc:discount.code', 'discount_code'].forEach(function (chave) {
      try {
        var v = localStorage.getItem(chave);
        if (v && baixo.indexOf(v.toLowerCase()) === -1) localStorage.removeItem(chave);
      } catch (e) {}
    });
  }
  function pedirCupom(codigo, ativos) {
    return trocarCupons(ativos.concat([codigo]));
  }
  function tirarCupom(codigo, ativos) {
    var resto = ativos.filter(function (c) {
      return c.toLowerCase() !== String(codigo).toLowerCase() && c !== '~' && c !== 'SD_CLEAR_DISCOUNT';
    });
    sincronizarApps(codigo, resto);
    return trocarCupons(resto);
  }
  function redesenhar() {
    if (typeof window.updateCart === 'function') window.updateCart();
  }
  function ocupar(sim) {
    cupomOcupado = sim;
    var botao = raiz.querySelector('[data-ng-aplicar]');
    if (botao) botao.disabled = sim;
  }

  function aplicarCupom() {
    var campo = raiz.querySelector('[data-ng-cupom]');
    if (!campo || cupomOcupado) return;
    var codigo = campo.value.replace(/\s+/g, '').trim();
    if (!codigo) { mensagemCupom = { tipo: 'erro', texto: 'Digite o código do cupom.' }; aplicarMensagemCupom(); return; }
    function mesmo(c) { return String(c).toLowerCase() === codigo.toLowerCase(); }
    ocupar(true);
    mensagemCupom = { tipo: 'aviso', texto: 'Aplicando…' };
    aplicarMensagemCupom();
    var escreveu = false;
    cuponsFrescos().then(function (ativos) {
      if (ativos.some(mesmo)) {
        mensagemCupom = { tipo: 'aviso', texto: 'O cupom ' + codigo.toUpperCase() + ' já está aplicado.' };
        return null;
      }
      escreveu = true;
      return pedirCupom(codigo, ativos).then(function (carrinho) {
        var dele = (carrinho.discount_codes || []).filter(function (d) { return mesmo(d.code); })[0];
        if (dele && dele.applicable) {
          mensagemCupom = { tipo: 'ok', texto: 'Cupom ' + codigo.toUpperCase() + ' aplicado.' };
          return null;
        }
        // Não vale: tira de novo para o carrinho não levar um cupom recusado até o checkout.
        mensagemCupom = { tipo: 'erro', texto: 'Não deu para usar o cupom ' + codigo.toUpperCase() + '. Confira o código ou se ele vale para estas peças.' };
        return dele ? tirarCupom(dele.code, ativos.concat([dele.code])) : null;
      });
    }).catch(function () {
      mensagemCupom = { tipo: 'erro', texto: 'Não foi possível aplicar agora. Tente de novo em instantes.' };
    }).then(function () {
      ocupar(false);
      if (mensagemCupom && mensagemCupom.tipo === 'ok') { var c = raiz.querySelector('[data-ng-cupom]'); if (c) c.value = ''; }
      aplicarMensagemCupom();
      if (escreveu) redesenhar(); else desenharCupons();
    });
  }

  function removerCupom(codigo) {
    if (cupomOcupado) return;
    ocupar(true);
    cuponsFrescos().then(function (ativos) {
      return tirarCupom(codigo, ativos);
    }).then(function () {
      mensagemCupom = { tipo: 'aviso', texto: 'Cupom ' + String(codigo).toUpperCase() + ' removido.' };
    }).catch(function () {
      mensagemCupom = { tipo: 'erro', texto: 'Não foi possível remover agora. Tente de novo em instantes.' };
    }).then(function () {
      ocupar(false);
      aplicarMensagemCupom();
      redesenhar();
    });
  }

  raiz.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-ng-aplicar]')) { ev.preventDefault(); aplicarCupom(); return; }
    var remover = ev.target.closest('[data-ng-remover-cupom]');
    if (remover) { ev.preventDefault(); removerCupom(remover.getAttribute('data-ng-remover-cupom')); }
  });

  // ---------- Frete pelo CEP ----------
  // O cálculo é o mesmo do checkout e da página do produto (assets/naguirre-frete.js): a sacola é
  // copiada para um carrinho separado; nada é adicionado ao carrinho da cliente.
  var cotacaoEmCurso = 0;
  var refeitas = 0; // contas descartadas seguidas porque o carrinho mudou no meio
  var ultimo = null; // { assinatura, html, resumo, frete } — devolve o resultado depois de cada redesenho

  // Muda quando muda o que pesa no frete: peças, quantidades, total e cupons.
  function assinatura() {
    var total = raiz.querySelector('[data-cart-total-value]');
    var partes = [total ? total.getAttribute('data-cart-total-value') : '', cuponsAtivos().join(',')];
    raiz.querySelectorAll('[data-cart-quantity][data-line]').forEach(function (q) {
      partes.push(q.getAttribute('data-line') + 'x' + q.value);
    });
    return partes.join('|');
  }
  function escreverResumo(t) {
    var resumo = raiz.querySelector('[data-ng-frete-resumo]');
    if (resumo && t && resumo.textContent !== t) resumo.textContent = t;
  }
  // Mesmo formato do total do tema (money_without_trailing_zeros): "R$ 1.234,50", "R$ 150".
  function moeda(c) {
    var reais = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var cent = c % 100;
    return 'R$\u00a0' + reais + (cent ? ',' + (cent < 10 ? '0' : '') + cent : ''); // \u00a0: "R$" nunca fica sozinho no fim da linha
  }
  // Total: "sem frete" até a cliente calcular. Depois, soma o frete mais barato (a opção que o checkout
  // já abre marcada) e diz qual foi: "com frete de R$ 9,90" / "com frete grátis". Vale só enquanto o
  // carrinho for o mesmo da conta; mudou, volta a "sem frete" até a conta nova chegar. O valor do tema
  // ([data-cart-total-value]) fica intacto e escondido: os apps de cupom escrevem nele.
  function aplicarTotal() {
    var li = raiz.querySelector('[data-ng-total]');
    if (!li) return;
    var sub = li.querySelector('[data-ng-total-sub]');
    var tema = li.querySelector('[data-cart-total-value]');
    var nosso = li.querySelector('[data-ng-total-com-frete]');
    var base = tema ? parseInt(tema.getAttribute('data-cart-total-value'), 10) : NaN;
    var vale = ultimo && typeof ultimo.frete === 'number' && ultimo.assinatura === assinatura() && nosso && !isNaN(base);
    aplicarMetaFrete(vale && ultimo.frete === 0);
    if (!vale) {
      li.classList.remove('is-com-frete');
      if (sub) { sub.textContent = 'sem frete'; sub.classList.remove('is-gratis'); }
      return;
    }
    nosso.textContent = moeda(base + ultimo.frete);
    if (sub) {
      sub.textContent = ultimo.frete === 0 ? 'com frete grátis' : 'com frete de ' + moeda(ultimo.frete);
      sub.classList.toggle('is-gratis', ultimo.frete === 0);
    }
    li.classList.add('is-com-frete');
  }
  // Frete grátis antes da meta (cupom de frete, ex.: GUGAFRETE; o Liquid não enxerga cupom de frete):
  // quando a conta da Shopify dá de graça a opção mais barata, a barra verde diz o mesmo que o total
  // ("Você ganhou frete grátis!", frase do <template> do Liquid). Carrinho mudou: volta ao que era.
  function aplicarMetaFrete(gratis) {
    var meta = raiz.querySelector('[data-ng-meta-frete]');
    if (!meta) return;
    var texto = meta.querySelector('.ng-meta__texto');
    var barra = meta.querySelector('.ng-meta__barra');
    var trilho = meta.querySelector('.ng-meta__trilho');
    var modelo = meta.querySelector('template[data-ng-meta-frete-gratis]');
    if (!texto || !barra || !modelo) return;
    var trocada = meta.classList.contains('is-por-conta');
    if (gratis && !trocada) {
      if (meta.classList.contains('is-completa')) return; // já ganhou pela regra da loja
      meta.__ngAntes = { html: texto.innerHTML, largura: barra.style.width, valor: trilho && trilho.getAttribute('aria-valuenow') };
      texto.innerHTML = modelo.innerHTML;
      barra.style.width = '100%';
      if (trilho) trilho.setAttribute('aria-valuenow', '100');
      meta.classList.add('is-completa', 'is-por-conta');
    } else if (!gratis && trocada && meta.__ngAntes) {
      texto.innerHTML = meta.__ngAntes.html;
      barra.style.width = meta.__ngAntes.largura;
      if (trilho && meta.__ngAntes.valor != null) trilho.setAttribute('aria-valuenow', meta.__ngAntes.valor);
      meta.classList.remove('is-completa', 'is-por-conta');
    }
  }

  function calcular(cep, silencioso) {
    var NF = window.NaguirreFrete;
    var alvo = raiz.querySelector('[data-ng-frete-resultado]');
    if (!NF || !alvo) return;
    if (NF.soDigitos(cep).length !== 8) {
      if (!silencioso) alvo.innerHTML = '<p class="ng-frete__erro">Digite os 8 números do CEP.</p>';
      return;
    }
    var painel = raiz.querySelector('[data-ng-painel="frete"]');
    var gratisMin = parseInt(painel && painel.getAttribute('data-gratis-min'), 10) || 0;
    var gratisTeto = parseInt(painel && painel.getAttribute('data-gratis-teto'), 10) || 0;
    var minha = ++cotacaoEmCurso;
    var marca = '';
    var versao = versaoCupons;
    if (!silencioso) alvo.innerHTML = '<p class="ng-frete__aviso">Calculando…</p>';
    NF.lerCarrinho().then(function (sacola) {
      // A leitura também traz os cupons: a assinatura da conta sai com a lista certa.
      if (versao === versaoCupons) conferirCarrinho(sacola);
      marca = assinatura();
      if (!sacola.linhas.length) return null;
      return NF.cotar({ linhas: sacola.linhas, cep: cep, codigos: sacola.codigos, gratisMin: gratisMin, gratisTeto: gratisTeto })
        .catch(function (e) {
          // A Shopify recusou por um tempo as tarifas pelo caminho novo: usa as do carrinho (rota antiga).
          if (e && e.tipo === 'indisponivel' && typeof NF.cotarPeloCarrinho === 'function') {
            return NF.cotarPeloCarrinho({ cep: cep, subtotal: sacola.total, gratisMin: gratisMin, gratisTeto: gratisTeto });
          }
          throw e;
        });
    }).then(function (resultado) {
      if (minha !== cotacaoEmCurso || !resultado) return;
      NF.gravarCep(cep);
      if (!silencioso) {
        NF.gravarCepNoCarrinho(cep); // o checkout já abre com o CEP e a UF
        NF.marcarCalculou();         // a partir daqui, nesta visita, o total da gaveta vem com frete
      }
      // O carrinho mudou durante a conta (app de cupom reaplicando, presente entrando): o resultado é de
      // outro carrinho. Não escreve nada (o resumo dizia "Grátis" e o total "sem frete") e refaz em
      // silêncio com o carrinho novo, no máximo 3 vezes seguidas.
      if (marca !== assinatura()) {
        if (++refeitas <= 3) { clearTimeout(esperaFrete); esperaFrete = setTimeout(function () { calcular(cep, true); }, 400); }
        return;
      }
      refeitas = 0;
      var barata = NF.maisBarata(resultado);
      var cupomDeFrete = (cuponsCarrinho || []).some(function (x) { return x.applicable && !x.nasPecas; });
      var nota = !resultado.viaCarrinho ? 'mesmos valores do checkout'
        : cupomDeFrete ? 'o desconto do cupom entra no checkout' : 'valores do checkout';
      ultimo = { assinatura: marca, html: NF.desenhar(resultado, nota), resumo: NF.resumo(resultado), frete: barata ? barata.centavos : null };
      var alvoAgora = raiz.querySelector('[data-ng-frete-resultado]'); // a gaveta pode ter sido redesenhada
      if (alvoAgora) alvoAgora.innerHTML = ultimo.html;
      escreverResumo(ultimo.resumo);
      aplicarTotal();
      marcarRodape();
    }).catch(function (e) {
      if (minha !== cotacaoEmCurso) return;
      ultimo = null; // sem conta que valha: o total volta a "sem frete"
      aplicarTotal();
      escreverResumo('Inserir CEP');
      var alvoAgora = raiz.querySelector('[data-ng-frete-resultado]');
      if (alvoAgora) alvoAgora.innerHTML = '<p class="ng-frete__erro">' + NF.escapar((e && e.message) || 'Não foi possível calcular agora. Tente de novo em instantes.') + '</p>';
    });
  }

  raiz.addEventListener('input', function (ev) {
    if (ev.target.matches && ev.target.matches('[data-ng-cep]') && window.NaguirreFrete) {
      ev.target.value = window.NaguirreFrete.mascara(ev.target.value);
    }
  });
  raiz.addEventListener('click', function (ev) {
    if (!ev.target.closest('[data-ng-calcular]')) return;
    ev.preventDefault();
    var campo = raiz.querySelector('[data-ng-cep]');
    if (campo) calcular(campo.value, false);
  });
  // Enter no campo faz o mesmo que o botão (não há <form> na gaveta).
  raiz.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || !ev.target.matches) return;
    if (ev.target.matches('[data-ng-cep]')) { ev.preventDefault(); calcular(ev.target.value, false); }
    else if (ev.target.matches('[data-ng-cupom]')) { ev.preventDefault(); aplicarCupom(); }
  });

  // Depois de um redesenho: mesmo carrinho, devolve o último resultado; carrinho mudou e a cliente já
  // calculou nesta visita (na gaveta ou na página do produto), refaz a conta em silêncio (frete grátis
  // e R$ 9,90 dependem do valor). Nunca calcula sozinho para quem não calculou.
  var esperaFrete = null;
  function freteDepoisDoRedesenho() {
    var NF = window.NaguirreFrete;
    var campo = raiz.querySelector('[data-ng-cep]');
    if (!NF || !campo) return;
    var cep = NF.lerCep();
    if (cep && !campo.value) campo.value = NF.mascara(cep);
    if (ultimo && ultimo.assinatura === assinatura()) {
      var alvo = raiz.querySelector('[data-ng-frete-resultado]');
      if (alvo && !alvo.innerHTML) alvo.innerHTML = ultimo.html;
      escreverResumo(ultimo.resumo);
      aplicarTotal();
      return;
    }
    aplicarTotal();
    if (!cep || !(ultimo || NF.jaCalculou())) return;
    clearTimeout(esperaFrete);
    esperaFrete = setTimeout(function () { calcular(cep, true); }, 600);
  }

  // ---------- Depois de cada redesenho da gaveta ----------
  function depoisDoRedesenho() {
    var lista = raiz.querySelector('.previewCart');
    raiz.classList.toggle('ng-lista-rolada', !!(lista && lista.scrollTop > 4));
    aplicarPaineis();
    aplicarMensagemCupom();
    desenharCupons();
    lerCuponsDoCarrinho();
    raiz.querySelectorAll('[data-ng-sugestoes]').forEach(atualizarSetas);
    freteDepoisDoRedesenho();
    marcarRodape();
  }
  document.addEventListener('cart-update', function () { setTimeout(depoisDoRedesenho, 0); });
  var lista = raiz.querySelector('.previewCart-wrapper') || raiz;
  var agendado = false;
  new MutationObserver(function () {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () { agendado = false; if (raiz.querySelector('[data-ng-rodape]')) depoisDoRedesenho(); });
  }).observe(lista, { childList: true });
  // Gaveta aberta sem redesenho (o HTML veio com a página): confere os cupons e o frete ao abrir.
  // Também trava a rolagem da PÁGINA enquanto a gaveta está aberta (classe no <html>): o tema só põe
  // overflow hidden no <body>, e como o <html> do tema tem overflow-x hidden, isso não chega à janela.
  // No celular, o dedo na gaveta descia a página do produto por trás (no tema no ar já no 1º arrasto;
  // no rascunho, quando a lista chegava ao fim). Fechou, destrava, e a página fica onde estava.
  var estavaAberta = document.body.classList.contains('cart-sidebar-show');
  document.documentElement.classList.toggle('ng-gaveta-aberta', estavaAberta);
  new MutationObserver(function () {
    var aberta = document.body.classList.contains('cart-sidebar-show');
    if (aberta !== estavaAberta) document.documentElement.classList.toggle('ng-gaveta-aberta', aberta);
    if (aberta && !estavaAberta && raiz.querySelector('[data-ng-rodape]')) { lerCuponsDoCarrinho(); freteDepoisDoRedesenho(); }
    estavaAberta = aberta;
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
